import React from 'react'
import moment from 'moment'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class OnLocationContent extends React.Component {
  render() {
    if (typeof window === 'undefined') return <main />
    const { children, trip, skip } = this.props
    if (skip) return children
    const tripData = config.trips[trip]
    const tripPath = `/${trip}`
    const cutoffDateUTC = moment.utc(tripData.onLocationPricingCutoff)
    let onLocationPricingAvailable = false

    if (tripData.onLocationPricingAvailable) {
      onLocationPricingAvailable = cutoffDateUTC.diff(moment.utc()) > 0
      if (!onLocationPricingAvailable) {
        setTimeout(() => (window.location.href = tripPath), 7000)
      }
    }
    if (onLocationPricingAvailable) return children
    return (
      <main>
        <div className="wrap content">
          <div className="content centered">
            <h1 className="centered">On-Location Rates No Longer Available</h1>
            <p>
              Redirecting you to the
              <strong>
                {' '}
                {tripData.name} | {tripData.year}{' '}
              </strong>
              main page&hellip;
            </p>
            <p>
              <a className="btn" href={tripPath}>
                Continue
              </a>
            </p>
          </div>
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/onlocation-content.js